import React, { Fragment, useEffect, useState } from "react";
import classnames from "classnames";
import _ from "lodash";
import DateTimePicker from "../../../components/DateTimePicker";
const OfferScheduling = ({ selectedDate, onChangeTime, isVisible }) => {
  const [scheduling, setScheduling] = useState({});
  useEffect(() => {
    onChangeTime(scheduling);
  }, [scheduling]);
  useEffect(() => {
    let postNow = true;
    if (selectedDate) postNow = false;
    const newScheduling = _.cloneDeep(scheduling);
    newScheduling.postNow = postNow;
    setScheduling(newScheduling);
  }, [selectedDate]);
  const handlePostNowChanged = (value) => {
    const newScheduling = _.cloneDeep(scheduling);
    newScheduling.postNow = value;
    setScheduling(newScheduling);
  };
  const handleChangeStartTime = (time) => {
    const newScheduling = _.cloneDeep(scheduling);
    newScheduling.startTime = time.valueOf();
    newScheduling.scheduledDate = time.valueOf();
    setScheduling(newScheduling);
  };
  const handleChangeEndTime = (time) => {
    const newScheduling = _.cloneDeep(scheduling);
    newScheduling.endTime = time.valueOf();
    setScheduling(newScheduling);
  };
  return (
    <div
      className={`broadcast-schedule-container ${!isVisible ? "d-none" : ""}`}
    >
      <p className="schedule-title">
        {!selectedDate && (
          <React.Fragment>
            <b>Start now</b> or{" "}
          </React.Fragment>
        )}
        <b>Schedule</b>
      </p>
      {!selectedDate && (
        <div className="schedule-container">
          <div
            className={classnames("check-box", {
              checked: scheduling.postNow,
            })}
            onClick={() => handlePostNowChanged(true)}
            style={{
              marginLeft: "20px",
            }}
          ></div>
          <div
            className={classnames("check-box", {
              checked: !scheduling.postNow,
            })}
            onClick={() => handlePostNowChanged(false)}
            style={{
              marginLeft: "80px",
            }}
          ></div>
        </div>
      )}
      {selectedDate ? (
        <Fragment>
          <h5 className="section-title">From</h5>
          <p className="schedule-time">{selectedDate.format("LLL")}</p>
          <h5 className="section-title">Until</h5>
          <DateTimePicker onTimeChange={handleChangeStartTime} />
        </Fragment>
      ) : (
        <Fragment>
          {scheduling.postNow ? null : (
            <Fragment>
              <h5 className="section-title">From</h5>
              <DateTimePicker onTimeChange={handleChangeStartTime} />
              <h5 className="section-title">Until</h5>
              <DateTimePicker onTimeChange={handleChangeEndTime} />
            </Fragment>
          )}
        </Fragment>
      )}
    </div>
  );
};
export default OfferScheduling;



// WEBPACK FOOTER //
// ./src/screens/Perks/components/OfferScheduling.js